sn-disclaimer-type-2 {
  .sn-disclaimer-type-2 {
    padding-bottom: px-to-rem(60px);

    @include desktop {
      padding-bottom: px-to-rem(82px);
    }

    @include above(960px) {
      padding-bottom: px-to-rem(120px);
    }

    @include above(1200px) {
      padding-bottom: px-to-rem(140px);
    }
  }

  .sn-disclaimer-type-2__container {
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 px-to-rem(16px);

    @include desktop {
      padding: 0 px-to-rem(24px);
    }
  }

  .sn-disclaimer-type-2__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  // ── Heading ───────────────────────────────────────────────────────
  .sn-disclaimer-type-2__heading {
    text-align: center;
    width: 100%;

    me-heading {
      display: block;
      font-weight: 700;
      font-size: px-to-rem(20px);
      line-height: px-to-rem(28px);
      margin-top: 0;
      margin-bottom: px-to-rem(12px);

      @include desktop {
        font-size: px-to-rem(24px);
        line-height: px-to-rem(32px);
      }

      @include above(960px) {
        font-size: px-to-rem(28px);
        line-height: px-to-rem(40px);
        margin-bottom: px-to-rem(17px);
      }

      @include above(1200px) {
        font-size: px-to-rem(36px);
        line-height: px-to-rem(48px);
      }
    }
  }

  // ── Description ───────────────────────────────────────────────────
  .sn-disclaimer-type-2__description {
    text-align: center;
    margin: 0 auto px-to-rem(24px);
    width: 100%;

    @include desktop {
      max-width: px-to-rem(542px);
    }

    @include above(960px) {
      max-width: px-to-rem(854px);
      margin-bottom: px-to-rem(32px);
    }

    @include above(1200px) {
      margin-bottom: px-to-rem(60px);
    }

    me-text {
      display: block;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(22px);

      @include above(960px) {
        font-size: px-to-rem(16px);
        line-height: px-to-rem(28px);
      }

      @include above(1200px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(32px);
      }
    }
  }

  // ── Dashed note box ───────────────────────────────────────────────
  .sn-disclaimer-type-2__note-box {
    position: relative;
    width: 100%;
    padding: px-to-rem(16px) px-to-rem(20px) px-to-rem(16px) px-to-rem(60px);
    border: 1px dashed #0182e8;
    border-radius: var(--radius-size-sm); // 4px

    @include above(960px) {
      font-size: px-to-rem(16px);
      line-height: px-to-rem(28px);
    }

    // Book icon
    &::after {
      position: absolute;
      content: '';
      top: px-to-rem(18px);
      left: px-to-rem(19px);
      width: px-to-rem(24px);
      height: px-to-rem(24px);
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDUuMDAwMTRDOS43NyAyLjc3MDE0IDYuMjk3IDIuNTQxMTQgMy44MTIgNC4zMTMxNEMzLjI5NCA0LjY4MjE0IDMgNS4yOTQxNCAzIDUuOTMwMTRWMTguODg2MUMzIDE5LjY2MDEgMy44MjUgMjAuMTA5MSA0LjUwOCAxOS43NDUxQzYuOTE1IDE4LjQ2MjEgOS45NzIgMTguODM1MSAxMiAyMC44NjQxVjUuMDAwMTRDMTQuMjMgMi43NzAxNCAxNy43MDMgMi41NDExNCAyMC4xODggNC4zMTMxNEMyMC43MDYgNC42ODIxNCAyMSA1LjI5NDE0IDIxIDUuOTMwMTRWMTguODg2MUMyMSAxOS42NjAxIDIwLjE3NSAyMC4xMTAxIDE5LjQ5MiAxOS43NDUxQzE3LjA4NSAxOC40NjIxIDE0LjAyOCAxOC44MzUxIDEyIDIwLjg2NDEiIHN0cm9rZT0iIzAxODJFOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      background-size: contain;
      background-repeat: no-repeat;
    }

    me-text {
      display: block;
    }
  }
}
